import React, { useEffect, useState } from 'react';


function Auth()  {
  const authToken = sessionStorage.getItem('authToken');
  const baseurl = process.env.REACT_APP_BASE_API_URL;
  
  // useEffect(() => {
  //   // Disable right-click context menu
  //   const handleContextMenu = (e) => {
  //     e.preventDefault();
  //   };

  //   // Attach the event listener to the entire document
  //   document.addEventListener('contextmenu', handleContextMenu);

  //   // Cleanup the event listener when the component unmounts
  //   return () => {
  //     document.removeEventListener('contextmenu', handleContextMenu);
  //   };
  // }, []);

  useEffect(() => {
    const fetchProfileData = async () => {

      //  console.log('Token ', authToken);
        try {
          if (!authToken) {
            handleLogout();
            return;
          }
  
          const response = await fetch(`${baseurl}/profile`, {
            method: 'GET',
            headers: {
              'Content-Type': 'application/json',
              Authorization: `Bearer ${authToken}`,
            },
          });
  
          if (response.status === 429) {
       //     console.error("Rate limit exceeded. Please try again later.");
            return; // Stop further processing
          }
  
          const result = await response.json();

         // console.log('User Data 1' ,result.status);
  
          if(result.status){

          //  console.log('User Dara',result);
            
          } else {
            handleLogout();

          //  console.log('User Daranot found');
          }
        } catch (error) {
       //   console.error('Fetch error:', error);
          handleLogout();
        }
      };

    fetchProfileData();
  }, [authToken]);

  // Function to clear local data and redirect to Signin
  const handleLogout = () => {
    localStorage.clear();
    window.location.href = "/signin";
  };

  
  
  return (
    <>
      {/* You can render profile data if needed */}
    </>
  );
}

export default Auth;
